import axiosClient from "../axiosClient";

export const licensePlateUniview = {
    get: (params) => {
        return axiosClient.get('camALPRCropRegion/get-list-cam-alpr-lines/', {
            params
        })
    },
    put: (data, params) => {
        return axiosClient.put("camALPRCropRegion/put-set-alpr-lines/", data, {
            params
        })
    },
    putChangeObject: (data, params ) => {
        return axiosClient.put('aiConfig/put-set-alpr-detect-type/', data, {
            params
        })
    },
    getObject: (params) => {
        return axiosClient.get(`aiConfig/get-list-alpr-detect-type/`, {
            params
        })
    },
    getNumlanes: (params) => {
        return axiosClient.get(`camALPRCropRegion/get-list-cam-alpr-num-lanes/`, {
            params
        })
    },
    
    putSetNumlanes: (params, data) => {
        // num_lanes : 3
        return axiosClient.put(`camALPRCropRegion/put-set-alpr-lines-by-num-lanes/`, data, {
            params
        })
    },

}